<template>
  <div class="w-8 h-8 flex items-center mr-2">
    <template v-if="cardType === 'default'">
      <CreditCardIcon />
    </template>
    <template v-else>
      <img class="" :src="require(`@/assets/images/${cardType}.png`)" />
    </template>
  </div>
</template>
<script>
import { CreditCardIcon } from "@heroicons/vue/outline"

export default {
  props: {
    type: {
      type: String,
      default: "default"
    }
  },
  components: {
    CreditCardIcon
  },
  computed: {
    cardType() {
      switch (this.type) {
        case "Visa":
        case "MasterCard":
        case "Discover":
        case "JCB":
        case "Maestro":
          return this.type.toLowerCase()
        case "American Express":
          return "amex"
        case "Diners Club":
          return "dinersclub"
        case "Visa Electron":
          return "visa-electron"
        default:
          return "default"
      }
    }
  }
}
</script>
